export default [
  {
    path: '/reporting',
    name: 'Reporting',
    component: () => import('@/views/reporting/index.vue'),
  },
];
